<template>
  <edit-page
    :selectedNavItem="selectedNavItem"
    :toggleForm="toggleForm"
    @form-submited="submit()"
  >
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field
        dense
        label="Unit Name"
        :rules="NoEmptyRule"
        filled
        required
        v-model="requestData.unitName"
      ></v-text-field>

      <v-text-field
        dense
        label="Unit Symbol"
        :rules="NoEmptyRule"
        filled
        required
        v-model="requestData.unitSymbol"
      ></v-text-field>

      <v-textarea
        dense
        label="Description"
        :rules="NoEmptyRule"
        filled
        rows="10"
        required
        v-model="requestData.description"
      ></v-textarea>
      <v-text-field
        dense
        label="To Minute Conversion Rate"
        :rules="NoEmptyRule"
        filled
        required
        type="number"
        v-model="requestData.toMinuteConversionRate"
      ></v-text-field>
      <!-- <v-select
        :items="institutions"
        item-text="UnitName"
        filled
        return-object
        v-model="requestData.SelectedInstitution"
        :rules="[(v) => !!v || '*Required']"
        label="Institution"
      ></v-select> -->
    </v-form>
  </edit-page>
</template>
<script>
import EditPage from "../EditPage.vue";
import apiClient from "../../API/apiClient";
import { mapGetters } from "vuex";
export default {
  components: { EditPage },
  name: "edit-collection-protocol-event-uniti-of-measurement",
  props: ["selectedNavItem", "toggleForm"],
  created() {
    this.requestData = this.selectedEditObject;
  },
  data() {
    return {
      valid: false,
      departments: [],
      requestData: {
        unitName: "",
        unitSymbol: "",
        description: "",
        toMinuteConversionRate: 0,
        SelectedInstitution: null,
        institutionId: null,
      },
      institutions: [],
      name: "",
      NoEmptyRule: [(v) => !!v || "*required"],
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.requestData.institutionId = this.currentInstitution.id;
        apiClient
          .call(
            "PUT",
            "institutions/" +
              this.currentInstitution.id +
              "/collectionProtocolEventUnitOfMeasurements/" +
              this.selectedEditObject.id,
            this.requestData
          )
          .then((response) => {
            console.log(response);
            this.toggleForm();
            this.$store.dispatch(
              "getCollectionProtocolEventUnitOfMeasurements"
            );
          })
          .catch((err) => console.log(err));
      }
    },
  },
  computed: {
    ...mapGetters(["currentInstitution", "selectedEditObject"]),
  },
};
</script>